import styled from 'styled-components'
import { Card, CardHeader } from 'shards-react'

export const CardCustomized = styled(Card)`
    min-height: 75vh;
`

export const CardHeaderCustomized = styled(CardHeader)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
